import { funlidayRequest } from './main';
import { getClientId } from '../utilities/uuid_util';
import { TRIP_PERMISSION } from '../constants/trips';

export const getV2TripList = (
  offset = 0,
  limit = 20,
  permission = TRIP_PERMISSION.READ
) => funlidayRequest.get('v2/trips');

export const updateV2Trip = params => {
  const { tripId, ...rest } = params;
  const newParams = { ...rest, deviceId: getClientId() };
  return funlidayRequest.put(`v2/trips/${tripId}`, newParams);
};

/** @methods getTripList - 取得我的行程清單
 * @param {String} skip (Optional) 要省略多少行程數
 * @param {String} limit (Optional) 此 Fetch 行程數上限
 * @returns {Promise} axiosPromise
 */
export const getTripList = (skip = '0', limit = '30') => {
  const params = { skip, limit, deviceId: getClientId() };
  return funlidayRequest.post('getTripList', params);
};

/** @methods getSharedTripList - 取得已分享(已被加入群組)行程清單
 * @param {String} skip (Optional) 要省略多少行程數
 * @param {String} limit (Optional) 此 Fetch 行程數上限
 * @returns {Promise} axiosPromise
 */
export const getSharedTripList = (skip = '0', limit = '30') => {
  const params = { skip, limit, deviceId: getClientId() };
  return funlidayRequest.post('getSharedTripList', params);
};

/** @methods updatePublicStatus - 更新行程的或是蒐藏景點開放等級(私人、透過連結分享、公開)
 * @param {String} id (Required) Trip unique ID.
 * @param {String} publicStatus (Required) "0":私人 | "1":透過連結分享 | "2":公開
 * @param {number} type (Required) 2: trip, 4: collection folder
 * @returns {Promise} axiosPromise
 */
export const updatePublicStatus = (id, publicStatus, type) => {
  const params = {
    id,
    publicStatus,
    type
  };
  return funlidayRequest.post('updatePublicStatus', params);
};

/** @methods deleteTrip - 刪除行程(只有 owner 才能刪除)
 * @param {String} parseTripObjectId (Required) Trip unique ID.
 * @returns {Promise} axiosPromise
 */
export const deleteTrip = parseTripObjectId => {
  const params = {
    parseTripObjectId,
    deviceId: getClientId()
  };
  return funlidayRequest.post('deleteTrip', params);
};

/** @methods createTrip - 新增行程
 * @param {Object} param (Required) paramObject
 * @param {String} param.tripName (Required) 行程名稱
 * @param {String} param.startDate (Required) 開始時間
 * @param {String} param.dayCount (Required) 天數
 * @param {String} param.coverNumber (Required) 行程封面圖片
 * @returns {Promise} axiosPromise
 */
export const createTrip = ({
  tripName,
  startDate,
  dayCount,
  coverNumber,
  userCities
}) => {
  const params = {
    tripName,
    startDate,
    dayCount,
    coverNumber,
    userCities,
    deviceId: getClientId()
  };
  return funlidayRequest.post('createTrip', params);
};

/** @methods getPoisOfTrip - 取得行程(包含pois)完整資料
 * @param {Object} param (Required) paramObject
 * @param {String} param.parseTripObjectId (Required) 該行程 ID
 * @param {Number} param.skip (Required) 要略過多少筆 poi 資料
 * @param {Number} param.limit (Required) poi 每次取回來的 poi 資料長度限制
 * @param {Object} param.signal (Optional)透過 signal 可在外部呼叫時終止 AJAX
 * @returns {Promise} axiosPromise
 */
export const getPoisOfTrip = ({
  parseTripObjectId,
  skip = 0,
  limit = 1000,
  signal
}) => {
  const params = { parseTripObjectId, skip, limit };
  const headers = {};
  if (signal) headers.cancelToken = signal.token;
  return funlidayRequest.post('getPoisOfTrip', params, headers);
};

/** @methods addPoiToTrip - 將景點加入行程
 * @param {Object} param (Required) paramObject
 * @description legacy API，理論上應該拆成好幾隻 API，大量參數請直接見文件..
 * @see http://114.32.168.43:5566/funliday/index.html#api-Trips-addPoi
 * @returns {Promise} axiosPromise
 */
export const addPoiToTrip = param => funlidayRequest.post('addPoi', param);

/** @methods getTripTemplates - 取得 onboarding 模板行程
 * @returns {Promise} axiosPromise
 */
export const getTripTemplates = signal => {
  const headers = {};
  if (signal) headers.cancelToken = signal.token;
  return funlidayRequest.get('v2/trips/templates', {}, headers);
};

export const getRecommendTrips = campaignId => {
  let params = {};

  if (campaignId) {
    params = {
      params: { campaign: campaignId }
    };
  }
  return funlidayRequest.get('v2/trips/templates', params);
};

/** @methods addProductToTrip - Add product to itinerary
 * @param {Object} param (Required) paramObject
 * @param {String} param.tripId (Required) Trip ID.
 * @param {String} param.revision (Required) Version number of the itinerary.
 * @param {String} param.daySequence (Required) Day sequence.
 * @param {Number} param.type (Required) ID type 1 (oid), 2 (product id)
 * @param {String} param.id (Required) id
 * @returns {Promise} axiosPromise
 */
export const addProductToTrip = ({
  tripId,
  revision,
  daySequence,
  type,
  id
}) => {
  const params = {
    tripId,
    revision,
    daySequence,
    type,
    id
  };
  return funlidayRequest.post('addProductToTrip', params);
};
